module.exports = __webpack_public_path__ + "static/media/abcd.979cc62e.png";